import * as React from "react";
import Header from "./Header";
import { useSelector } from "react-redux";
import { getTemplateDefs } from "../../helpers/grid";
import InsertDot from "./InsertDot";

const RowHeaders = () => {
  const rows = useSelector((state) => state.gridd.present.structure.rows);
  const readOnly = useSelector((state) => state.app.readOnlyMode);

  return (
    <div
      id="row_headers"
      style={{
        display: "grid",
        gridTemplateRows: getTemplateDefs(rows),
        zIndex: 999,
      }}
    >
      {rows ? (
        rows.map((row, j) => (
          <div
            key={j}
            style={{
              width: 24,
              display: "flow",
              position: "relative",
              height: "100%",
            }}
          >
            {!readOnly ? (
              <>
                <InsertDot vertical={false} index={j} />
                <Header vertical={false} index={j} />
                {j == rows.length - 1 ? (
                  <div
                    style={{
                      position: "relative",
                    }}
                  >
                    <InsertDot vertical={false} index={j + 1} />
                  </div>
                ) : (
                  <></>
                )}
              </>
            ) : (
              <></>
            )}
          </div>
        ))
      ) : (
        <></>
      )}
    </div>
  );
};

export default RowHeaders;
